module.exports = __webpack_public_path__ + "img/logo.6e421959.png";